import { MMKV } from 'react-native-mmkv'
import getLogger from './getLogger'

const logger = getLogger('mmkvStorage', 'warn')

export type PersistedData<T> = {
  data: T | undefined
  updatedAt: number
}

const createMmkvStorage = <T>(id: string) => {
  const storage = new MMKV({
    id,
  })

  const persist = (key: string, data: T) => {
    logger.log('Persist', Date.now(), data)

    storage.set(
      key,
      JSON.stringify({
        data,
        updatedAt: Date.now(),
      })
    )
  }
  const load = (key: string) => {
    try {
      const data = storage.getString(key)
      if (!data) {
        throw new Error('No data')
      }

      const parsed = JSON.parse(data)

      return parsed as PersistedData<T>
    } catch (ex) {
      return {
        data: null,
        updatedAt: 1,
      }
    }
  }

  const remove = (key: string) => {
    storage.delete(key)
  }

  const clear = () => {
    storage.clearAll()
  }

  return {
    persist,
    load,
    remove,
    clear,
  }
}

export default createMmkvStorage
